export const CONTRACT_DETAIL_FEATURE_KEY = 'contractDetail';